module.exports = __webpack_public_path__ + "img/img14.58bc8525.jpg";